import React, { useCallback, useState } from "react";
import { useEditorStore } from "../../../../state/editorStore";
import { WatermarkToolIcon } from "../../../../icons";
import WatermarkControls from "../Popup/WatermarkControls";
import {
  DEFAULT_WATERMARK_SETTINGS,
} from "../Popup/watermarkSettings";
import styles from "./Watermark.module.css";

const OFF_WATERMARK = {
  enabled: false,
  ...DEFAULT_WATERMARK_SETTINGS,
};

/**
 * Editor left-panel watermark card — reuses prep WatermarkControls.
 */
const Watermark = ({ defaultExpanded = false, forceExpanded = false }) => {
  const watermark = useEditorStore((s) => s.object.watermark);
  const setWatermark = useEditorStore((s) => s.setWatermark);

  const mergeWatermark = useCallback(
    (updates) => {
      const prev = useEditorStore.getState().object.watermark || {};
      setWatermark({ ...prev, ...updates, enabled: true });
    },
    [setWatermark]
  );

  const [expanded, setExpanded] = useState(
    Boolean(defaultExpanded || forceExpanded)
  );
  const isExpanded = forceExpanded || expanded;

  const settings = {
    ...DEFAULT_WATERMARK_SETTINGS,
    ...(watermark || {}),
  };

  return (
    <div
      className={styles.card}
      onClick={() => {
        if (!forceExpanded) setExpanded((prev) => !prev);
      }}
    >
      <div className={styles.header}>
        <div className={styles.left}>
          <span className={styles.icon}>
            <WatermarkToolIcon />
          </span>
          <span className={styles.title}>Watermark</span>
        </div>

        <div className={styles.right}>
          <label
            className={styles.switch}
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="checkbox"
              checked={Boolean(watermark?.enabled)}
              onChange={(e) => {
                if (!e.target.checked) {
                  setWatermark(OFF_WATERMARK);
                } else {
                  setWatermark({
                    ...DEFAULT_WATERMARK_SETTINGS,
                    ...(watermark || {}),
                    enabled: true,
                  });
                }
              }}
            />
            <span className={styles.slider}></span>
          </label>

          {!forceExpanded ? (
            <button
              type="button"
              className={`${styles.chevron} ${isExpanded ? styles.chevronOpen : ""}`}
              aria-label={isExpanded ? "Collapse" : "Expand"}
              onClick={(e) => {
                e.stopPropagation();
                setExpanded((prev) => !prev);
              }}
            >
              ›
            </button>
          ) : null}
        </div>
      </div>

      {isExpanded && watermark?.enabled ? (
        <div
          className={styles.body}
          onClick={(e) => e.stopPropagation()}
        >
          <WatermarkControls
            settings={settings}
            hideFormatControls
            positionStageSelector=".editor-page__canvas-stack"
            colorPickerAnchorSelector=".editor-left-menu-object-tools"
            presetMenuAnchorSelector=".editor-left-menu-subject-controls-wrapper"
            presetMenuAnchorTopSelector=".editor-left-menu-subject-controls-wrapper"
            onChange={mergeWatermark}
          />
        </div>
      ) : null}
    </div>
  );
};

export default Watermark;
